<mat-card-title>{{'ecase.common.approvalCycle.approvalLevels'| eCaseTranslate}}</mat-card-title>
<div style="width: 100%">
  <button style="float: right;margin-right: 0 !important;" mat-raised-button class="eCase-dialog-positive-action-button"
          [disabled]="effectiveIsCompetitionClosed || availableApprovalCycles.length === 0"
          (click)="addApprover()">
    {{'ecase.common.approvalCycle.addapprovers'| eCaseTranslate}}
  </button>
  <button style="float: right;" mat-raised-button class="eCase-dialog-positive-action-button"
          [disabled]="effectiveIsCompetitionClosed"
          (click)="manageCycle()">
    {{'ecase.common.approvalCycle.manage.cycle'| eCaseTranslate}}
  </button>
</div>
<br>
<br>
<form *ngIf="addApproversForm"  [formGroup]="addApproversForm" autocomplete="off">
  <table mat-table class="ecase-mat-table"
         style="margin-top: 0px"
         id="ecase_admindashboard_competitions_competition_approval_levels_table"
         [dataSource]="dataSource"
         [@animateStagger]="{value:'50'}">

    <ng-container matColumnDef="approvalCycleDescriptionId">
      <th mat-header-cell *matHeaderCellDef>
        <u>
          {{'ecase.common.approvalCycle.approvalCycleDescription' | translate}}
        </u>
      </th>
      <ng-container *matCellDef="let row">
        <td mat-cell [title]="'ecase.common.approvalCycle.approvalCycleDescription' | translate" style="padding-right: 24px">
          <div *ngIf="row.isParent" fxLayout="row" fxLayoutAlign="start center">
            <div style="display: flex;align-items: center;">
              <button (click)="toggleChildren(row)" class="mat-icon-button" mat-icon-button>
                <mat-icon>{{row.isShowChildren ? 'remove_circle_outline' : 'add_circle_outline'}}</mat-icon>
              </button>
            </div>
            <span [attr.aria-label]="'ecase.common.approvalCycle.approvalCycleDescription' | translate" class="approval-cycle-description-text">
              {{ displayFn2(row.approvalCycleDescriptionId) || row.approvalCycleDescription }}
            </span>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="approverName">
      <th mat-header-cell *matHeaderCellDef>
        <u>
          {{'ecase.common.approvalCycle.approver' | translate}}
        </u>
      </th>
      <ng-container *matCellDef="let row; let i = index">
        <td mat-cell [title]="'ecase.common.approvalCycle.approver' | translate" style="padding-right: 24px">
        <ng-container *ngIf="row.isChild">
          <mat-form-field appearance="outline">
            <input [id]="'cap_approver' + (i + 1)" type="text" matInput [formControlName]="'approver' + (i + 1)" [name]="'approver' + (i + 1)" [attr.aria-label]="'ecase.common.approvalCycle.approver' | translate" [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="updateSsoUserId($event, i, row.oldIndex)">
              <mat-option *ngFor="let approver of filteredApprovers[i]" [value]="approver.ssoUserId">{{approver.name}}</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="addApproversForm.get('approver' + (i + 1))?.errors?.required">
              {{'ecase.common.thisfieldismandatory' | translate}}
            </mat-error></mat-form-field>
        </ng-container>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="approvalLevel">
      <th mat-header-cell *matHeaderCellDef>
        <u>
          {{'ecase.common.approvalCycle.approvalLevel' | translate}}
        </u>
      </th>
      <ng-container *matCellDef="let row; let i = index">
        <td mat-cell [title]="'ecase.common.approvalCycle.approvalLevel' | translate" style="padding-right: 24px">
        <ng-container *ngIf="row.isChild">
          <mat-form-field appearance="outline" [style.width.%]="isMobile ? 100 : 50">
            <input [attr.aria-label]="'ecase.common.approvalCycle.approvalLevel' | translate" [formControlName]="'approvalLevel' + (i + 1)" [min]="1" [max]="5" type="number" matInput maxlength="1">
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.required">
              {{'ecase.common.thisfieldismandatory' | translate}}
            </mat-error>
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.min">
              {{'ecase.admindashboard.competitions.awardFinalization.approvers.error.minapprovers' | translate}}
            </mat-error>
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.max">
              {{'ecase.admindashboard.competitions.awardFinalization.approvers.error.maxapprovers' | translate}}
            </mat-error>
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.duplicateApprovalLevel">
              {{'ecase.admindashboard.competitions.awardFinalization.duplicateApprovalLevel' | translate}}
            </mat-error>
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.levelSkipped">
            {{replaceLevel('ecase.admindashboard.competitions.awardFinalization.skiplevel' | translate)}}
          </mat-error>
            <mat-error *ngIf="addApproversForm.get('approvalLevel' + (i + 1))?.errors?.invalidLevel">
              {{replaceLevel('ecase.admindashboard.competitions.awardFinalization.invalidLevel' | translate)}}
            </mat-error>
          </mat-form-field>
        </ng-container>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="isNotified">
      <th mat-header-cell *matHeaderCellDef>
        <u>
          {{'ecase.common.approvalCycle.isNotified' | translate}}
        </u>
      </th>
      <ng-container *matCellDef="let row; let i = index">
        <td mat-cell [title]="'ecase.common.approvalCycle.isNotified' | translate" style="padding-right: 24px">
        <ng-container *ngIf="row.isChild">
          <mat-checkbox style="font-size: 14px; width: 50%" [formControlName]="'isNotified' + (i + 1)" [attr.aria-label]="'ecase.common.approvalCycle.isNotified'| eCaseTranslate">
            <span class='nodisplay'>.
            </span>
          </mat-checkbox>
        </ng-container>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="trash">
      <th mat-header-cell *matHeaderCellDef><span class='nodisplay'>.</span>
      </th>
      <td mat-cell *matCellDef="let row" style="text-align: center;" [title]="'ecase.common.approvalCycle.delete' | eCaseTranslate">
        <button *ngIf="row.isParent && cycleTypeId != null && +row.approvalCycleDescriptionId > 0" type="button" mat-icon-button [disabled]="effectiveIsCompetitionClosed" [style.opacity]="effectiveIsCompetitionClosed ? 0.5 : 1" (click)="openConfirmDeleteApprovalCycle(row); $event.stopPropagation()" aria-label="Delete approval cycle">
          <mat-icon>delete
          </mat-icon>
        </button>
      </td>
    </ng-container>


    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span class='nodisplay'>.</span>
      </th>
      <td mat-cell *matCellDef="let row" [title]="'ecase.common.action' | eCaseTranslate">
      <ng-container *ngIf="row.isChild">
        <button (click)="menuTrigger.openMenu();$event.stopPropagation()" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" class="mat-icon-button eCase-in-table-mat-button" id="ecase_competition_approval_levels_row_menu" aria-label="{{'ecase.competitionProgram.more'| eCaseTranslate}}" matTooltip="{{'ecase.competitionProgram.more'| eCaseTranslate}}">
          <mat-icon>more_vert
          </mat-icon>
          <span>{{ 'ecase.common.action' | eCaseTranslate }}
          </span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="removeApprover(row)" id="ecase_competition_approval_levels_action_delete">{{'ecase.common.approvalCycle.delete' | eCaseTranslate}}
          </button>
        </mat-menu>
      </ng-container>
      </td>
    </ng-container>

    <ng-container class="filter_row_first_cell mat-elevation-z4" matRipple matColumnDef="header-row-first-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.
        </span>
        <div class="form-item" style="margin: 0 !important;">
          <div class="select-wrap">
            <input type="image" *ngIf="showImage" disabled matRipple class="row_filter_icon" src="/assets/images/etc/icons8-conversion.svg" alt="clear">
            <input type="image" *ngIf="!showImage" class="row_filter_icon" src="/assets/images/etc/icons8-clear-filters.svg" alt="clear" (click)="resetFilters(true)">
            <select class="select_filter filter-items__element--select" required id="ecase_competition_approval_levels_table_cycle_filter" [attr.aria-label]="'ecase.common.approvalCycle.approvalCycleDescription' | eCaseTranslate" [ngModelOptions]="{standalone: true}" [(ngModel)]="filterObjectForSelectFields.approvalCycleDescriptionId" (change)="applyFilter()">
              <option role="option" selected value="">{{'Select' | eCaseTranslate}}
              </option>
              <option role="option" *ngFor="let cycle of availableApprovalCycles" [value]="cycle.id">{{cycle.description}}
              </option>
            </select>
          </div>
        </div>
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-second-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.
        </span>
        <input type="text" class="searchFields" id="ecase_competition_approval_levels_table_approver_filter" [attr.aria-label]="'ecase.common.approvalCycle.approver' | eCaseTranslate" [(ngModel)]="filterObject.approverName" [ngModelOptions]="{standalone: true}" [placeholder]="'ecase.admindashboard.search' | eCaseTranslate" (keyup)="applyFilter()">
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-third-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.
        </span>
        <input type="text" class="searchFields" id="ecase_competition_approval_levels_table_level_filter" [attr.aria-label]="'ecase.common.approvalCycle.approvalLevel' | eCaseTranslate" [(ngModel)]="filterObject.approvalLevel" [ngModelOptions]="{standalone: true}" [placeholder]="'ecase.admindashboard.search' | eCaseTranslate" (keyup)="applyFilter()">
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-fourth-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.</span>
      </th>
    </ng-container>


    <ng-container matColumnDef="header-row-fifth-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.</span>
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-trash-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.</span>
      </th>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-header-row *matHeaderRowDef="['header-row-first-group', 'header-row-second-group', 'header-row-third-group', 'header-row-fourth-group', 'header-row-trash-group', 'header-row-fifth-group']"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="row.isParent ? 'td-grey-color' : ''" [style.display]="row.isParent || row.isChildVisible ? '' : 'none'"></tr>
  </table>
  <mat-paginator *ngIf="dataSource.data.length > 0" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
</form>
<br>
<div *ngIf="isStandalonePaApprovals()" style="width: 100%; padding-bottom: 10px">
  <button (click)="cancelStandalonePaApprovers()" *eCaseNgIfWithSysActionIdsOr="[1253,1255]" [disabled]="effectiveIsCompetitionClosed" class="eCase-dialog-negative-action-button" mat-raised-button style="float: right;">{{ 'ecase.common.cancel' | eCaseTranslate }}</button>
  <button (click)="saveStandalonePaApprovers()" *eCaseNgIfWithSysActionIdsOr="[1253,1255]" [disabled]="effectiveIsCompetitionClosed" class="eCase-dialog-positive-action-button" mat-raised-button style="float: right; margin-right: 12px;">{{'ecase.common.save' | eCaseTranslate}}</button>
</div>
<br>
<br>
